import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { isEmpty } from 'lodash'

import NotAuthorized from 'pages/NotAuthorized'
import Loader from 'components/Loader'

import { getIsVenuesLoading, getVenues } from 'store/Venues/selector'
import { fetchVenues } from 'store/Venues/actions'
import { isAuth, checkIfIsLoopedLogin } from 'utils/auth'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch()
  const isVenuesLoading = useSelector(getIsVenuesLoading)
  const isVenuesEmpty = isEmpty(useSelector(getVenues))

  useEffect(() => {
    dispatch(fetchVenues())
  }, [])

  const renderPage = (isVenuesEmpty, props) => {
    if (isVenuesLoading) return <Loader />

    if (isVenuesEmpty) {
      return <NotAuthorized />
    } else {
      return <Component {...props} />
    }
  }
  return (
    <Route
      {...rest}
      render={(props) => (isAuth() ? renderPage(isVenuesEmpty, props) : checkIfIsLoopedLogin())}
    />
  )
}

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
}

export default PrivateRoute
